import React, { useEffect, useState, useRef } from 'react'
import Menu from '../main/Menu'
import {
    getProcessButtons, getError, isUndNullEmpNew, isUndNullNew, sendMessageCloseCurrentWindow, setBadgeStatusGeneric, settings, getResponse, LoadingSection,
    getLanguageObj, awaitDelay, getDtRowIndexNew
} from '../../helpers/UtilsHelper'
import useAuth from '../../auth/useAuth';
import Swal from 'sweetalert2';
import AdvancedCommandAddEditDetails from './AdvancedCommandAddEditDetails';
import { AdvancedCommandClass } from '../../classes/ai/advancedCommandClass';
import { SwalPropertiesClass } from '../../classes/main/swalPropertiesClass';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import TableIndex from '../main/TableIndex';
import { AdvancedCommandService } from '../../services/advancedCommand/AdvancedCommandService';

const { app, colors, firebase, html, icons, images, labels, messages, react, timers, } = settings;
const { fields: dbFields, operators: dbOperators, ordersBy: dbOrdersBy, } = firebase?.firestore;
const { sweetAlert2, } = react;
const { urls } = app?.backend;

const $ = window?.$;

const currentMethod = 'AdvancedCommand - function';

export default function AdvancedCommand({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const auth = useAuth();
    const isMount = useRef(true);
    const [process, setProcess] = useState({ showLoading: false, add: false });

    const dtAdvancedCommandsId = 'dtAdvancedCommands';
    const [advancedCommand, setAdvancedCommand] = useState(AdvancedCommandClass?.getClass());
    const [processValues, setProcessValues] = useState({
        id: '',
        description: '',
        method: '',
        dtId: dtAdvancedCommandsId,
        dtRowId: 0,
        type: 0,
    });
    const [showModal, setShowModal] = useState(false);
    const textAreaAnswerId = 'textAreaAnswer';
    //#endregion variables

    //#region methods (advancedCommands)
    const getAdvancedCommandAddEditDelete = async ({
        e = {},
        id = '',
        description = '',
        rowIndex = 0,
        type = 0,
        subMethod = ''
    }) => {
        const currentMethod = 'getAdvancedCommandAddEditDelete';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            if (type !== -1) setProcess(prev => ({ ...prev, showLoading: true, add: type === 0 }));

            setProcessValues(prev => ({
                ...prev,
                id: id,
                description: description,
                method: subMethod,
                dtRowId: rowIndex,
                type: type
            }));

            let advancedCommand_ = AdvancedCommandClass?.getClass();

            switch (type) {
                case -1:
                    //#region show message
                    let msgTextObj = {
                        one: messages?.areYouSureDeleteThis?.[languageObj?.id],
                        two: `${labels?.advancedCommand?.[languageObj?.id]}: <b>${description}</b><br/>`,
                        three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                    };

                    let swalProperties = SwalPropertiesClass?.getClass();
                    swalProperties = {
                        icon: sweetAlert2?.icons?.warning,
                        title: msgTextObj?.one,
                        html: `${msgTextObj?.two}${msgTextObj?.three}`,
                        timer: null,
                        backdrop: true,
                        confirmButtonColor: colors?.warningColorExp,
                        confirmButtonText: labels?.yes?.[languageObj?.id],
                        showCancelButton: true,
                        cancelButtonColor: colors?.successColorExp,
                        cancelButtonText: labels?.no?.[languageObj?.id],
                        showLoaderOnConfirm: true,
                        customClass: {
                            popup: html?.popup,
                            confirmButton: html?.buttons?.primary,
                            cancelButton: html?.buttons?.secondary,
                        },
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                        allowOutsideClick: () => !Swal?.isLoading(),
                        preConfirm: async () => {
                            let preConfirmResponse = getResponse({ type: 0 });
                            try {
                                Swal.getCancelButton().hidden = true;
                                Swal.update({
                                    icon: sweetAlert2?.icons?.info,
                                    title: `${messages?.processing?.[languageObj?.id]}`,
                                    html: `${msgTextObj?.two}`,
                                    showConfirmButton: false,
                                });

                                preConfirmResponse = await AdvancedCommandService.deleteById({
                                    id: id,
                                    token: auth?.account?.tokenVzLaML?.token,
                                    subMethod: currentMethod
                                });
                                if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;

                                $(`#${dtAdvancedCommandsId}`).DataTable().row(rowIndex).remove().draw(true);
                                preConfirmResponse.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
                            } catch (ex) {
                                preConfirmResponse = getError({ ex: ex, response: preConfirmResponse, currentMethod_: currentMethod, subMethod_: subMethod });
                            }
                            return preConfirmResponse;
                        }
                    };
                    //#endregionshow message

                    const swalresult = await Swal.fire({
                        ...swalProperties,
                    });
                    if (swalresult?.isConfirmed && swalresult?.value) {
                        response = swalresult?.value;
                    } else if (swalresult?.isDismissed) {
                        response = getResponse({ type: 0 });
                    }
                    break;
                case 0:
                    advancedCommand_.accountId = auth?.account?.uid;
                    advancedCommand_.status = true;
                    setAdvancedCommand(advancedCommand_);
                    break;
                case 1:
                    await awaitDelay({ delayTime: timers?.oneSeconds });
                    response = await getAdvancedCommandById({
                        id: id,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                    advancedCommand_ = Object?.assign(advancedCommand_, response?.result?.advancedCommand || {});
                    setAdvancedCommand(advancedCommand_);
                    break;
                case 2:
                    response = await getAdvancedCommandById({
                        id: id,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                    advancedCommand_ = Object?.assign(advancedCommand_, response?.result?.advancedCommand || {});
                    setAdvancedCommand(advancedCommand_);
                    break;
                default:
                    return;
            }

            if (type === 0 || type === 1 || type === 2) {
                await awaitDelay({ delayTime: timers?.oneSeconds });
                setShowModal(true);
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            if (type !== -1) setProcess(prev => ({ ...prev, showLoading: false, add: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const getData = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            let advancedCommandsDt_ = [];
            let advancedCommands_ = [AdvancedCommandClass?.getClass()];
            advancedCommands_ = [];

            setProcess(prev => ({ ...prev, showLoading: true }));

            response = setDataTable({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = clearDataTable({ dtAdvancedCommands: true, subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setQueryCode({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            const data = {
                conditionals: [
                    { field: dbFields?.accountId, operator: dbOperators?.equal, value: auth?.account?.uid, },
                ],
                ordersBy: [
                    { field: dbFields?.description, value: dbOrdersBy?.asc, },
                ],
                limit: 0,
            };

            response = await AdvancedCommandService.getAll({
                token: auth?.account?.tokenVzLaML?.token,
                data: data,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            advancedCommands_ = !isUndNullNew({ data: response?.result?.advancedCommands, subMethod: currentMethod, })?.result ? response?.result?.advancedCommands : advancedCommands_;

            if (!isUndNullNew({ data: advancedCommands_, subMethod: currentMethod, })?.result && advancedCommands_?.length > 0) {
                advancedCommands_?.map((detail) => (
                    advancedCommandsDt_.push([
                        detail?.description,
                        setBadgeStatusGeneric({
                            type: (detail?.status ? 0 : 1),
                            value: (detail?.status ? labels?.enabled?.[languageObj?.id] : labels?.disabled?.[languageObj?.id])
                        }),
                        getProcessButtons({
                            id: detail?.id,
                            description: detail?.description,
                            detailsShow: false,
                            detailsLabel: labels?.detail?.[languageObj?.id],
                            detailsEnabled: false,
                            editShow: true,
                            editLabel: labels?.edit?.[languageObj?.id],
                            editEnabled: true,
                            deleteShow: true,
                            deleteLabel: labels?.delete?.[languageObj?.id],
                            deleteEnabled: true,
                            processButtons: [],
                            languageId: languageObj?.id,
                            subMethod: currentMethod
                        })?.result
                    ])
                ))
            }

            $(`#${dtAdvancedCommandsId}`).DataTable().rows.add(advancedCommandsDt_).draw(true);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const getAdvancedCommandById = async ({
        id = '',
        subMethod = '',
    }) => {
        const currentMethod = 'getAdvancedCommandById';
        let response = getResponse({ type: 0 });
        try {
            response = await AdvancedCommandService.getById({
                id: id,
                token: auth?.account?.tokenVzLaML?.token,
                subMethod: currentMethod
            });
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }
    //#endregion methods (advancedCommands)

    //#region methods (others)
    const setDataTable = ({
        subMethod = '',
    }) => {
        const currentMethod = 'setDataTable';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtAdvancedCommandsId}`).DataTable({
                destroy: true,
                data: [],
                order: [[0, 'asc']],
                columns: [
                    { title: labels?.description?.[languageObj?.id], width: '85%', orderable: true, },
                    { title: labels?.status?.[languageObj?.id], width: '10%', orderable: true, },
                    { className: 'text-center', title: labels?.process?.[languageObj?.id], width: '5%', orderable: false, searchable: false },
                ],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis'],
            }).buttons().container().appendTo(`#${dtAdvancedCommandsId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const clearDataTable = ({
        dtAdvancedCommands = false,
        subMethod = '',
    }) => {
        const currentMethod = 'clearDataTable';
        let response = getResponse({ type: 0 });
        try {
            if (dtAdvancedCommands) $(`#${dtAdvancedCommandsId}`).DataTable().rows().remove().draw(true);
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    }) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            let id = '';
            let rowIndex = 0;
            let methodName = '';
            let description = '';

            $(`#${dtAdvancedCommandsId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowIndex = getDtRowIndexNew({ dtId: dtAdvancedCommandsId, this_: this, subMethod: currentMethod })?.result;
                if (!isUndNullEmpNew({ data: rowIndex, subMethod: currentMethod, })?.result) {
                    methodName = e?.target?.attributes?.method?.value || '';
                    id = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            getAdvancedCommandAddEditDelete({ e, id: id, description: description, rowIndex: rowIndex, type: 1, subMethod: currentMethod });
                            break;
                        case 'delete':
                            getAdvancedCommandAddEditDelete({ e, id: id, description: description, rowIndex: rowIndex, type: -1, subMethod: currentMethod });
                            break;
                        default:
                            break;
                    }
                }
            });
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({
            subMethod: 'onLoad',
        });
        return () => { isMount.current = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='bots' process='advancedCommands' processLevel1='' />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>
                                    {labels?.advancedCommands?.[languageObj?.id]}
                                </h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home} className='link-primary-bold'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.advancedCommands?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-12'>
                                <div className={settings?.html?.cards?.default}>
                                    <LoadingSection alt='loadingSection'
                                        className='overlay dark text-white'
                                        height={20}
                                        hidden={!process?.showLoading}
                                        width={20}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header bg-white border-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt={labels?.advancedCommands?.[languageObj?.id]}
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={images?.icons?.advancedCommands || settings?.images?.icons?.advancedCommands} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.advancedCommands?.[languageObj?.id]}</h5>
                                                    <div className='mt-1'>
                                                        <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={{ ...html?.badges?.micro }}>
                                                            <i className={`${icons?.fasFa?.list} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-tools'>
                                                <button type='button'
                                                    className='btn btn-tool'
                                                    data-card-widget='collapse'>
                                                    <i className={icons?.fasFa?.minus} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='card-body pt-0'>
                                        <div className='d-flex flex-wrap justify-content-end align-items-center mb-3' style={{ gap: '8px' }}>
                                            <button className='btn btn-primary shadow-sm font-weight-bold px-4'
                                                disabled={process?.showLoading}
                                                data-title={labels?.add?.[languageObj?.id]}
                                                onClick={(e) => getAdvancedCommandAddEditDelete({ e: e, id: '', description: '', rowIndex: 0, type: 0, subMethod: 'btnAiAdd' })}>
                                                {!process?.add ? (
                                                    <i className={`${icons?.fasFa?.plusCircle} mr-1`}></i>
                                                ) : (
                                                    <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                )}  {labels?.add?.[languageObj?.id]}
                                            </button>
                                        </div>
                                        <TableIndex tableId={dtAdvancedCommandsId} languageObj={languageObj} />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>{/* /.container-fluid */}

                    {showModal && (
                        <AdvancedCommandAddEditDetails $={$}
                            auth={auth}
                            dtId={processValues?.dtId}
                            dtRowId={processValues?.dtRowId}
                            type={processValues?.type}
                            showModal={showModal}
                            setShowModal={setShowModal}
                            advancedCommand={advancedCommand}
                            setAdvancedCommand={setAdvancedCommand}
                            textAreaAnswerId={textAreaAnswerId} />
                    )}

                </section>
                {/* /.content */}
            </div>
        </div>
    )
}